/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Series_ElevationInputs */

const en_ui_chart_series_elevation = /** @type {(inputs: Ui_Chart_Series_ElevationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevation (m)`)
};

const de_ui_chart_series_elevation = /** @type {(inputs: Ui_Chart_Series_ElevationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höhe (m)`)
};

/**
* | output |
* | --- |
* | "Elevation (m)" |
*
* @param {Ui_Chart_Series_ElevationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_series_elevation = /** @type {((inputs?: Ui_Chart_Series_ElevationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Series_ElevationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_series_elevation(inputs)
	return de_ui_chart_series_elevation(inputs)
});